module.exports = __webpack_public_path__ + "scource/login-321c8-50f9f476.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/navigator/img/login-321c8.png
// module id = 427
// module chunks = 1